interface BatteryBarProps {
  percent: number;
  showLabel?: boolean;
  className?: string;
}

export function batteryColor(percent: number): string {
  if (percent < 10) return 'bg-accent-red';
  if (percent < 30) return 'bg-accent-orange';
  return 'bg-lime-500';
}

export function BatteryBar({ percent, showLabel = true, className = '' }: BatteryBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  const color = batteryColor(clamped);

  return (
    <div className={`w-full ${className}`}>
      <div
        className="h-2 w-full rounded-full bg-surface-600 overflow-hidden"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Battery health ${clamped}%`}
      >
        <div
          className={`h-full ${color} transition-all`}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && (
        <div className="mt-1 text-xs text-neutral-400">{clamped}% battery health</div>
      )}
    </div>
  );
}
